import {
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  Box,
  Text,
} from '@chakra-ui/react';
import { styleFontColor as style } from './utils';
import { FaqAccordionIcon } from './FaqAccordionIcon';

const renderAccordion = (isExpanded, Title, Body) => (
  <>
    <Text>
      <AccordionButton
        _expanded={{ bg: style.bgBlueGrey, color: style.txDarkGray }}
      >
        <Box flex="1" textAlign="left">
          {Title}
        </Box>
        <FaqAccordionIcon isExpanded={isExpanded} />
      </AccordionButton>
    </Text>
    <AccordionPanel p={4} bg={style.bgBlueGrey} color={style.txLightGrey}>
      {Body}
    </AccordionPanel>
  </>
);

export const ItemAccordion = ({ Title, Body }) => (
  <AccordionItem>
    {({ isExpanded }) => renderAccordion(isExpanded, Title, Body)}
  </AccordionItem>
);
